import React from "react";
import { Component } from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import ModalWindow from "../Common/ModalWindow";
import moment from "moment";

import Pagination from "react-js-pagination";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import Modal from "react-bootstrap/Modal";
import constant from "../../constant";
import TransactionInvoice from "./TransactionInvoice";
import Shimmer from "../Common/Shimmer";

export default class Transaction extends Component {
  constructor(props) {
    super(props);
    const emplpoyerDetail = this.props.details;
    this.state = {
      showModal: false,
      invoiceid: "",
    };
  }
  onshowModal = () => {
    this.setState({ showModal: true });
  };
  onMessageCancel = () => {
    this.setState({ showModal: false });
  };
  toggleModal = () => {
    this.setState({ showModal: false });
  };
  // const handlePageChange = (pageNumber) => {

  //     setCurrentPage(pageNumber);
  //     navigate(location.pathname + "?p=" + pageNumber)
  //     props.setPage(pageNumber)
  // };

  render() {
    const { details } = this.props;
    const { showModal, invoiceid } = this.state;

    return (
      <React.Fragment>
        {showModal && (
          <ModalWindow
            backdrop="static"
            toggleModal={() => {
              this.toggleModal();
            }}
            className="InvoiceModal"
            title={'Invoice'}

          >
            <TransactionInvoice
              onCancel={this.onhideModal}
              invoiceid={invoiceid}
              toggleModal={this.onMessageCancel}
            />
          </ModalWindow>

        )}
        <div className="main-content main-content-transaction">
          <div className="page-content">
            <div className="container" style={{ marginTop: "70px" }}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="card" style={{ border: "none" }}>
                    <div className="card-body pd-0">
                      <h4 className="card-title mb-4">Transaction Details</h4>
                      <div className="table-responsive">
                        <table className="table align-middle  table-hover ">
                          <thead className="table-light">
                            <tr>
                              <th scope="col">Invoice ID</th>

                              <th scope="col">Subscription Details</th>
                              <th scope="col">Transaction Details</th>

                              <th scope="col">Invoice</th>
                            </tr>
                          </thead>

                          <tbody>
                            {details === undefined && (
                              <tr>
                                <td colSpan={4}>
                                  <Shimmer />
                                </td>
                              </tr>
                            )}
                            {details && details.length > 0
                              ? details.map((ele, index, list) => {
                                return (
                                  <tr
                                    style={{
                                      whiteSpace: "inherit",
                                      lineHeight: "24px",
                                    }}
                                  >
                                    <td>JZSHRE{ele.PKG_SUBSC_ID}</td>

                                    <td>
                                      <h5
                                        className=" mb-1"
                                        style={{
                                          fontSize: "14px",
                                          width: "200px",
                                        }}
                                      >
                                        <a href="" className="text-dark">
                                          {ele.PACKAGE_TITE}{" "}
                                        </a>
                                      </h5>
                                      <p className="text-muted mb-0">
                                        Quantity : {ele.QTY}
                                      </p>
                                    </td>
                                    <td>
                                      <p>
                                        Payment ID :{" "}
                                        <span style={{ color: " #008040" }}>
                                          {ele.PAYMENT_ID}{" "}
                                        </span>
                                      </p>
                                      <p>
                                        Amount :{" "}
                                        <span style={{ color: " #008040" }}>
                                          {ele.AMOUNT}{" "}
                                        </span>
                                      </p>
                                      <p>
                                        Payment Status :{" "}
                                        <span style={{ color: "#008040" }}>
                                          {ele.PAYMENT_STATUS == "S" ? (
                                            <span>Successful</span>
                                          ) : ele.PAYMENT_STATUS == "F" ? (
                                            <span>Failure</span>
                                          ) : ele.PAYMENT_STATUS == "P" ? (
                                            <span> Processing </span>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                      </p>
                                      <p>
                                        Validity :{" "}
                                        <span style={{ color: " #f46a6a" }}>
                                          (End Date){" "}
                                          {moment(ele.END_DATE).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </span>
                                      </p>
                                    </td>
                                    <td>
                                      <div className="mt-4">
                                        {/* <a href={constant.component.TransactionInvoice.url} className="theme-btn" >Download</a> */}
                                        <button
                                          className="theme-btn"
                                          style={{ border: "none" }}
                                          onClick={() =>
                                            this.onshowModal(
                                              this.setState({
                                                invoiceid: ele.PKG_SUBSC_ID,
                                              })
                                            )
                                          }
                                        >
                                          View
                                        </button>
                                      </div>

                                      <br />
                                    </td>
                                  </tr>
                                );
                              })
                              : <tr>
                                <td colSpan={10} className="text-danger text-center">No Record Found</td>
                              </tr>}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
